<main class="fld-col jc-ctr">
  <section class="fld-col fld-dsk-col flg-5 ai-ctr jc-ctr card">
    <div class="fw-u1">
      <p>
        Please enter the credit card information used to pay for your
        membership.
      </p>
      <p>
        We will use this information to connect your account with MyQQ.
      </p>
      <p>This will not affect your billing total.</p>
    </div>
    <div class="card-form fld-col pwt-4 ai-stc fls-1-0">
      <mat-form-field id="card">
        <mat-label>Card</mat-label>
        <myqq-stripe-card
          matStripe
          name="credit-card-details"
          [formControl]="card"
          (change)="handleChange($event)"
        ></myqq-stripe-card>
      </mat-form-field>
      <form [formGroup]="form" class="fld-col">
        <mat-form-field id="name">
          <mat-label>Name</mat-label>
          <input
            matInput
            formControlName="name"
            (keydown.enter)="handleTokenize(form.value)"
          />
        </mat-form-field>
        <mat-form-field id="country">
          <mat-label>Country</mat-label>
          <select
            matNativeControl
            formControlName="address_country"
            (keyup.enter)="
              form.valid &&
                ($event.preventDefault() || handleTokenize(form.value))
            "
          >
            <option value="US">United States</option>
            <option value="CA">Canada</option>
          </select>
        </mat-form-field>
      </form>

      <section class="ta-c">
        <div
          *ngIf="(cardError || !card) && (form.touched || form.dirty)"
          class="cf-error validation-error"
        >
          {{ cardError || "Please enter a valid credit card number." }}
        </div>
        <div
          *ngIf="form.get('name').invalid && form.get('name').dirty"
          class="cf-error validation-error"
        >
          Please enter your name as it appears on the card.
        </div>
      </section>
    </div>

    <footer class="fld-row flg-5 jc-ctr vw-p100">
      <button
        myqq-button
        (click)="handleCancel()"
        (keyup.enter)="handleCancel()"
        (keydown.enter)="$event.preventDefault()"
        class="raised normal"
        type="button"
        aria-label="cancel"
      >
        Cancel
      </button>
      <div class="ta-c">
        <button
          myqq-button
          [disabled]="
            form.invalid || tokenizing || !card || cardError || !card.value
          "
          color="primary"
          class="raised normal"
          (click)="handleTokenize(form.value)"
          (keyup.enter)="handleTokenize(form.value)"
          (keydown.enter)="$event.preventDefault()"
          aria-label="next"
        >
          Next
        </button>
      </div>
    </footer>
  </section>
</main>
